import { useEffect, useMemo, useState } from "react";

import fetchGeoPlaces, {
  GeoPlace,
  GeoPlacesHook,
} from "~/components/Forms/DealerPassportForm2/requests/getGeoPlaces";

export const useGeoPlaces = ({
  type,
  parentId,
  prefix,
  isRu,
}: GeoPlacesHook) => {
  const [options, setOptions] = useState<GeoPlace[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);

      try {
        if (type === "country") {
          const data = await fetchGeoPlaces({
            type: "country",
            count: "10000",
          });
          setOptions(data);
        } else if (parentId) {
          const data = await fetchGeoPlaces({
            type: type,
            parentId: parentId,
            count: "10000",
          });
          setOptions(data);
        }
      } catch (err) {
        setError(
          `Ошибка при загрузке геоданных для ${prefix} (${type}): ${err}`,
        );
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [type, parentId, prefix]);

  useEffect(() => {
    if (error) {
      console.error(error);
    }
  }, [error]);

  const selectOptions = useMemo(() => {
    const defaultOption = {
      value: null,
      label: isRu ? "Не выбрано" : "Not chosen",
    };

    return [
      defaultOption,
      ...options.map((item) => {
        const option = {
          value: item.id,
          label: item.name,
        };

        if (type === "house") {
          return {
            ...option,
            indexAddress: item.index || null,
          };
        }

        return option;
      }),
    ];
  }, [options, isRu, type]);

  return {
    options: selectOptions,
    loading: loading,
    error: error,
  };
};
